import * as React from "react"
import { useCallback, useState } from "react"
import { MDXProvider, ComponentDictionary } from "@mdx-js/react"

import { VBox, Spacer, HBox, OnDevice, Icon, Code } from "@molnx-sites/common/components"
import classNames from "@molnx-sites/common/utils/classNames"

import { Page, PageHeader, PageSection, SEO, WithTableOfContents, H3, H4, H5, H6, H2 } from "src/components"

import styles from "src/components/DocPage/DocPage.module.scss"

export function DocPage(props: {
    title: string
    navigation?: any
    children?: any
}) {
    return (
        <Page>
            <SEO title={props.title}/>
            <PageHeader small noLogo header={props.title}/>
            <VBox fill>
                <OnDevice mobile tablet render={() => <MobilePage {...props} />}/>
                <OnDevice desktop render={() => <DesktopPage {...props} />}/>
            </VBox>
        </Page>
    )
}

function DesktopPage(props: {
    navigation?: any
    children?: any
}) {
    return (
        <div className={styles.DesktopPage}>
            <Spacer/>
            {props.navigation ?? <Spacer/>}
            <MainPageContent children={props.children}/>
            <Spacer/>
            <Spacer/>
        </div>
    )
}

function MobilePage(props: {
    navigation?: any
    children?: any
}) {
    return (
        <VBox fill>
            <MobileNavBar navigation={props.navigation}/>
            <MainPageContent children={props.children}/>
        </VBox>
    )
}

function MobileNavBar(props: {
    navigation?: any
}) {
    const [isOpen, setIsOpen] = useState(false)
    const onClick = useCallback(
        () => setIsOpen(!isOpen),
        [setIsOpen, isOpen])

    return (
        <PageSection className={classNames(styles.MobileNavBar, isOpen ? "open" : undefined)}>
            <HBox onClick={onClick} className={styles.MobileNavHeader}>
                <span>
                    <Icon solid={isOpen ? "chevron-down" : "chevron-right"}/>
                    {" "}
                    All Sections
                </span>
            </HBox>
            {isOpen && (
                <div>
                    {props.navigation}
                </div>
            )}
        </PageSection>
    )
}

function MainPageContent(props: {
    children?: any
}) {
    return (
        <WithTableOfContents>
            <PageSection>
                <MDXProvider
                    components={mdxComponents}
                    children={props.children}
                />
            </PageSection>
        </WithTableOfContents>
    )
}

const mdxComponents: ComponentDictionary = {
    pre: (props: any) => {
        return <Code>{props.children.props.children}</Code>
    },
    h2: (props: any) => {
        return <H2>{props.children}</H2>
    },
    h3: (props: any) => {
        return <H3>{props.children}</H3>
    },
    h4: (props: any) => {
        return <H4>{props.children}</H4>
    },
    h5: (props: any) => {
        return <H5>{props.children}</H5>
    },
    h6: (props: any) => {
        return <H6>{props.children}</H6>
    }
}